import React from 'react'
import { Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { PropTypes } from 'prop-types'

const InternationalizedFormattedText = ({
  children,
  className,
  variant,
  id,
  values,
  style,
  noWrap,
  display = 'block',
}) => {
  return (
    <Typography className={className} variant={variant} style={style} noWrap={noWrap} display={display}>
      <FormattedMessage id={id} values={values}>
        {children}
      </FormattedMessage>
    </Typography>
  )
}

InternationalizedFormattedText.propTypes = {
  variant: PropTypes.string,
  id: PropTypes.string,
}

export default InternationalizedFormattedText
